import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'

import lang from '../lang'

export default class extends React.Component {
  state = {
  }

  constructor(props) {
    super(props)
  }

  componentDidMount() {
  }

  componentWillReceiveProps(e) {
  }

  render() {
    let { language, lang, GroupSupper } = this.props
    return (
      <div className="roomGold">
        <div className="title">
          {lang.roomGold}
        </div>
        <div className="content">
          <div className="item">
            <div className="gold">
              {lang.lastWeek}
            </div>
            <div className="score">
              {GroupSupper && GroupSupper.lastWeekCoin || 0}
            </div>
          </div>
          <div className="line">
          </div>
          <div className="item">
            <div className="gold">
              {lang.thisWeek}
            </div>
            <div className="score">
              {GroupSupper && GroupSupper.weekCoin || 0}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/roomsupport-op/RoomGold/index.js